export default "__VITE_ASSET__71c58661__"